import noResultsImage from "@assets/empty-cart.png";
import Spacer from "@components/Spacer";
import Button from "@components/button";
import CustomImage from "@components/custom-image";
import { Text, View } from "dripsy";
import * as React from "react";
import { useNavigation } from "react-native-ridge-navigation";

import routes from "../../NavigatorRoutes";

export default function NotAuthorized({ onPress }: { onPress?: () => void }) {
  return (
    <View sx={{ alignItems: "center" }}>
      <Spacer size="$4" />
      <CustomImage source={noResultsImage as any} sx={{ height: 60 }} contentFit="contain" alt="Geen resultaten" />
      <Spacer size="$4" />

      <Text sx={{ fontSize: 18, fontWeight: "500", maxWidth: 400, textAlign: "center" }}>
        Beste klant, Leuk dat je bij ons wilt winkelen! Maak eerst even een account aan.
      </Text>
      <Spacer />

      <SignUpButton onPress={onPress} />
      <Spacer />
    </View>
  );
}

export function SignUpButton({ onPress }: { onPress?: () => void }) {
  const { push } = useNavigation();
  return (
    <Button
      onPress={() => {
        push(routes.LoginOrSignupScreen, {});
        onPress?.();
      }}
    >
      Start met jouw account
    </Button>
  );
}
